var React = require('react');

function Duplication (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Duplication"),React.createElement("path",{"fill":"#12ebae","d":"M25.231 0h-16c-1.699 0-3.077 1.378-3.077 3.077v0 3.077h-3.077c-1.699 0-3.077 1.378-3.077 3.077v0 19.692c0 1.699 1.378 3.077 3.077 3.077v0h16c1.699 0 3.077-1.378 3.077-3.077v0-3.077h3.077c1.699 0 3.077-1.378 3.077-3.077v0-19.692c0-1.699-1.378-3.077-3.077-3.077v0zM19.692 28.923c0 0.34-0.276 0.615-0.615 0.615v0h-16c-0.34 0-0.615-0.276-0.615-0.615v0-19.692c0-0.34 0.276-0.615 0.615-0.615v0h3.077v14.154c0 1.699 1.378 3.077 3.077 3.077v0h10.462zM25.846 22.769c0 0.34-0.276 0.615-0.615 0.615v0h-16c-0.34 0-0.615-0.276-0.615-0.615v0-19.692c0-0.34 0.276-0.615 0.615-0.615v0h16c0.34 0 0.615 0.276 0.615 0.615v0z","key":1})]);
}

Duplication.defaultProps = {"version":"1.1","width":"28","height":"32","viewBox":"0 0 28 32"};

module.exports = Duplication;

Duplication.default = Duplication;
